import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'copy-to-clipboard',
    standalone: true,
    imports: [TranslateModule, TooltipModule],
    templateUrl: './copy-to-clipboard.component.html',
    styleUrl: './copy-to-clipboard.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyToClipboardComponent {
    value = input.required<string>();
    icon = input<string>('fa fa-regular fa-copy');
    tooltip = input<string>('copyToClipboard');

    copied = output<void>();
    error = output<string>();

    isCopied = signal(false);

    get copiedState() {
        return this.isCopied();
    }

    async copyToClipboard(): Promise<void> {
        try {
            await navigator.clipboard.writeText(this.value());
            this.isCopied.set(true);
            this.copied.emit();

            // Reset the copied state after 2 seconds
            setTimeout(() => {
                this.isCopied.set(false);
            }, 2000);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to copy to clipboard';
            this.error.emit(errorMessage);
        }
    }
}
